import * as React from "react";
import { FvcSession, FvcAnalysisSet, FvcAnalysisSetTest } from "webportalclient";
import { FvcRepeatability, calculateFvcRepeatabilityTopTwoNew } from "../../Shared/RepeatabilityCalculations";
import { DynamicResultsGroupHeading } from "../../Shared/ResultsGroupHeading";
import { useResultsContext } from "../UseResultsContext";

interface TopTwoRepeatabilityProps {
    analysisSet: FvcAnalysisSet;
}

export const TopTwoRepeatability = ({ analysisSet }: TopTwoRepeatabilityProps) => {
    const { additionalColumnCount } = useResultsContext();
    const [fvcRepeatability, setFvcRepeatability] = React.useState<FvcRepeatability>(null);

    React.useEffect(() => {
        const repeatability = calculateFvcRepeatabilityTopTwoNew(analysisSet.tests);
        setFvcRepeatability(repeatability);
    }, [analysisSet]);

    if (!fvcRepeatability)
        return null;

    return (
        <>
            <DynamicResultsGroupHeading resultsCount={analysisSet.tests.length} title="Repeatability" />
            <tr>
                <td colSpan={analysisSet.tests.length + 1}>FVC</td>
                <td colSpan={additionalColumnCount - 1}>
                    {fvcRepeatability.fvcAbsolute !== null ? fvcRepeatability.fvcAbsolute.toFixed(2) : "-"}L ({fvcRepeatability.fvcPercentage !== null ? fvcRepeatability.fvcPercentage.toFixed(2) : "-"}%)
                </td>
            </tr>
            <tr>
                <td colSpan={analysisSet.tests.length + 1}>FEV1</td>
                <td colSpan={additionalColumnCount - 1}>
                    {fvcRepeatability.fev1Absolute !== null ? fvcRepeatability.fev1Absolute.toFixed(2) : "-"}L ({fvcRepeatability.fev1Percentage !== null ? fvcRepeatability?.fev1Percentage.toFixed(2) : "-"}%)
                </td>
            </tr>
        </>
    )

    
}
